import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Shared invalidation only; never treats a successful request as proof of completion. */
@Injectable({ providedIn: 'root' })
export class OnboardingRefreshService {
  readonly changes = new Subject<void>();
}
